import React from 'react'
import LogoSVG from "../assets/Logo-SVGs"
import styled from 'styled-components'
import Brightness from '../scripts/Brightness'

import {NavLink} from 'react-router-dom'
import TransitionGroup from 'react-transition-group/TransitionGroup'

import SiteIcons from '../assets/SiteIcons'

const TopNav = (props) => {

    const navLink = () => {
      props.navChange()
    }

    const ToggleMobileNav = () => {
      props.toggleMobileNav()
    }

    const NavChange = () => {
      props.navChange('hideNav')
    }


    let linkActive = ''

    const NavChangeLinks = () => {
      linkActive = 'active'
      props.navTypeChange('links')
      props.navChange()
    }

    let logText

    if ( props.loggedIn == false ) {
      logText = 'Preview login'
    } else {
      logText = 'Log out'
    }

    let mobileMenu = false
    let mobileClass = ''

    if ( props.mobile ) {
      mobileMenu = true
      mobileClass = 'mobile'
    } else {
      mobileMenu = false
      mobileClass = ''
    }


    const LinkActive = Brightness(props.themeStyles.topNavSVGHover, -.2)


    const TopBarStyles = styled.nav`
      background: ${props.themeStyles.topNavGradient};
      background-color: ${props.themeStyles.topNavBackground};
      border-bottom: solid 1px ${props.themeStyles.borderColor};
    `

    const TopNavLinks = styled(NavLink)`
      color: ${props.themeStyles.topNavText};
      border-left: solid 1px ${props.themeStyles.borderColor};

      .icon {
        #accent {
          stroke: ${props.themeStyles.topNavSVG};
        }

        #lines {
          stroke: ${props.themeStyles.topNavSVG};
        }

        #fill {
          fill: none;
        }

        &.alternate {
          #lines {
            stroke: ${props.themeStyles.svgColor};
          }
        }
      }

      &:hover {
        color: ${props.themeStyles.mainColor};
        background-color: ${props.themeStyles.topNavHoverBg};

        .icon {
          #accent {
            stroke: ${props.themeStyles.topNavHoverBg};
            stroke-width: 12px;
          }

          #lines {
            stroke: ${props.themeStyles.topNavSVGHover};
          }

          #fill {
            fill: ${props.themeStyles.topNavSVGHover};
          }

        }
      }

      &:active {
        color: ${LinkActive};

        .icon {

          #lines {
            stroke: ${LinkActive};
          }

          #fill {
            fill: ${LinkActive};
          }
        }
      }


      &.active {
        .icon {
          #accent {
            stroke: ${props.themeStyles.topNavSVGHover};
          }

          #lines {
            stroke: ${props.themeStyles.topNavSVGHover};
          }

          #fill {
            opacity: 0.3;
            fill: ${props.themeStyles.topNavSVGHover};
          }
        }

      }
    `

    const TopNavA = styled.a`
      color: ${props.themeStyles.topNavText};
      border-left: solid 1px ${props.themeStyles.borderColor};

      .icon {
        #accent {
          stroke: ${props.themeStyles.topNavSVG};
        }

        #fill {
          fill: none;
        }

        #lines {
          stroke: ${props.themeStyles.topNavSVG};
        }


      }

      &:hover {
        color: ${props.themeStyles.mainColor};
        background-color: ${props.themeStyles.topNavHoverBg};

        .icon {
          #accent {
            stroke: ${props.themeStyles.topNavBackground};
          }

          #lines {
            stroke: ${props.themeStyles.topNavSVGHover};
          }

          #fill {
            fill: ${props.themeStyles.topNavSVGHover};
          }

          &.alternate {
            #lines {
              stroke: ${props.themeStyles.topNavBackground};
            }
          }
        }
      }

      &:active {
        color: ${LinkActive};

        .icon {

          #lines {
            stroke: ${LinkActive};
          }

          #fill {
            fill: ${LinkActive};
          }
        }

      }
    `

    const MobileButton = styled.div`
      span {
        background: ${props.themeStyles.topNavText};
      }

      &:hover {
        span {
          background: ${props.themeStyles.topNavTextHover};
        }
      }
    `

    return (
      <TopBarStyles id="topNav" className={mobileClass}>
        <div className="logoContainer">
          {props.themeStyles.logoType === 'svg' &&
            <NavLink onClick={NavChange} exact to={"/"}><LogoSVG logo={props.themeStyles.logo} /></NavLink>
          }
          {props.themeStyles.logoType === 'img' &&
            <NavLink onClick={NavChange} exact to={"/"}><img alt="logo" src={props.themeStyles.logo}></img></NavLink>
          }
        </div>
        <div className="linksContainer">
          {mobileMenu === true &&
            <MobileButton className="mobileBttn" onClick={ToggleMobileNav}><span></span><span></span><span></span></MobileButton>
          }
          {mobileMenu === false &&
            <ul>
              {props.homeButton.length > 0 &&
                <li><TopNavLinks onClick={NavChange} exact activeClassName="active" to={"/"}><span className="iconContainer"><SiteIcons icon="home" /></span><span className="text">Home</span></TopNavLinks></li>
              }
              <li><TopNavLinks onClick={NavChange} activeClassName="active" to={"/courses/all-courses"}><span className="iconContainer"><SiteIcons icon="courses" /></span><span className="text">Courses</span></TopNavLinks></li>
              <li><TopNavLinks onClick={NavChange} exact activeClassName="active" to={"/requirements"}><span className="iconContainer"><SiteIcons icon="system" /></span><span className="text">System</span></TopNavLinks></li>
              <li><TopNavA onClick={NavChange} href={'https://' + props.localURL + '/index.php/json/login'}><span className="iconContainer"><SiteIcons icon="login" /></span><span style={{flexShrink: 0}} className="text">{logText}</span></TopNavA></li>
            </ul>
          }
        </div>
      </TopBarStyles>
    )

}

export default TopNav
